import { Draggable, Droppable } from 'react-beautiful-dnd';
import React from 'react';
import PropTypes from 'prop-types';
import { ScrollWrapper } from '../../../../../../ui-kit';
import LeadCard from '../leadCard';

const getStyleForDroppable = (isDragging, updateDroppable, droppableId, snapshot) => {
  if (isDragging && updateDroppable === droppableId) {
    return 'column-board__body--update';
  }
  if (isDragging && !snapshot.draggingFromThisWith) {
    return 'column-board__body--active';
  }
  return '';
};

const DroppableArea = ({
  statusId, isDragging, updateDroppable, leads, pipelineStatusId,
}) => (
  <Droppable droppableId={pipelineStatusId}>
    {(provided, snapshot) => (
      <div
        ref={provided.innerRef}
        className="column-board__drag"
        style={{
          backgroundColor: provided.isDragging ? 'green' : 'lightblue',
        }}
        {...provided.droppableProps}
      >
        <ScrollWrapper className="pipe-view__scroll-wrapper-column">
          <div className={`column-board__body ${getStyleForDroppable(isDragging, updateDroppable, statusId, snapshot)}`}>
            {leads.map((lead, index) => (
              <Draggable
                key={`lead-key ${lead.id}`}
                index={index}
                draggableId={lead.id}
              >
                {(providedDrag, draggableSnapshot) => (
                  <div
                    className="project-task__drag-wrapper"
                    ref={providedDrag.innerRef}
                    {...providedDrag.draggableProps}
                    {...providedDrag.dragHandleProps}
                  >
                    <LeadCard
                      key={`lead ${lead.id}`}
                      isDragging={draggableSnapshot.isDragging}
                      lead={lead}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        </ScrollWrapper>
      </div>
    )}
  </Droppable>
);

DroppableArea.propTypes = {
  statusId: PropTypes.number,
  isDragging: PropTypes.bool.isRequired,
  updateDroppable: PropTypes.number,
  leads: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

DroppableArea.defaultProps = {
  updateDroppable: null,
  statusId: null,
};

export default DroppableArea;
